import axios, { AxiosResponse } from "axios";

import {
  QuoteVM,
  ListQuoteVM,
  UpdateQuoteRequest,
  QuoteResponse,
  SamskipAPIResponse,
  FileResponse,
  QuoteDecline,
} from "@assets/types";

const SamskipAPI = process.env.SamskipAPI;

class QuoteService {
  createQuote = async (quote: QuoteVM): Promise<string> => {
    const res: AxiosResponse<SamskipAPIResponse<QuoteResponse>> =
      await axios.post(`${SamskipAPI}/quotes`, quote, {
        withCredentials: true,
      });
    return res.data.ReturnItem.Data.QuoteReference;
  };

  getQuotes = async () => {
    const res: AxiosResponse<SamskipAPIResponse<ListQuoteVM[]>> =
      await axios.get(`${SamskipAPI}/quotes`, { withCredentials: true });
    return res.data.ReturnItem.Data;
  };

  updateQuoteStatus = async (quote: UpdateQuoteRequest): Promise<string> => {
    const res: AxiosResponse<SamskipAPIResponse<string>> = await axios.patch(
      `${SamskipAPI}/quotes/${quote.QuoteReference}/status`,
      quote,
      {
        withCredentials: true,
      }
    );
    return res.data.ReturnItem.Data;
  };

  getQuoteEditVM = async (quoteReference: string): Promise<QuoteVM> => {
    const res: AxiosResponse<SamskipAPIResponse<QuoteVM>> = await axios.get(
      `${SamskipAPI}/quotes/${quoteReference}/editViewModel`,
      {
        withCredentials: true,
      }
    );
    return res.data.ReturnItem.Data;
  };

  getQuoteDeclineReasons = async () => {
    const res: AxiosResponse<SamskipAPIResponse<QuoteDecline[]>> =
      await axios.get(`${SamskipAPI}/quotes/reasons`, {
        withCredentials: true,
      });
    return res.data.ReturnItem.Data;
  };

  getQuoteFile = async (quoteReference: string): Promise<FileResponse> => {
    const res: AxiosResponse<ArrayBuffer> = await axios.get(
      `${SamskipAPI}/quotes/${quoteReference}/file`,
      {
        withCredentials: true,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/pdf",
        },
      }
    );
    const FileResponse = {
      FileName: quoteReference,
      Content: res.data,
      ContentType: res.headers["content-type"],
    };
    return FileResponse;
  };
}

export default new QuoteService();
